export default ({...props}) => {
  const {panelHighlight} = props.theme
  return `
      [ap_type="app_spinner"] {
        color: ${panelHighlight.foreground};
      }
    `
}
